export default __webpack_public_path__ + "static/media/uniswap_logo.3dea5939.png";